<template>
  <div id="searcher" :class="{ active: search != '' }">
    <div
      class="overlay"
      @click="
        search_list = false;
        filter_entity = false;
      "
      v-show="search_list || filter_entity"
    ></div>
    <div class="input">
      <div
        class="icon"
        @click="showFilterEntity"
        v-on:click.stop
        :class="{ expanded: entity }"
      >
        <div v-show="entity" class="entity">
          {{ ("search." + entity + ".label") | i18n }}
        </div>
      </div>
      <input
        type="text"
        name=""
        v-model="search"
        v-on:keyup.enter="doSearch()"
      />
    </div>
    <div v-show="filter_entity" class="entity_list">
      <div
        class="item"
        v-for="(item, i) in entities"
        :key="i"
        @click="setEntity(item.id)"
      >
        {{ $t(item.name) }}
      </div>
    </div>
    <div v-show="search_list" class="search_list" :class="{ expanded: entity }">
      <div
        v-if="values.length > 0"
        class="item"
        :class="[item.type]"
        v-for="(item, i) in values"
        :key="i"
        @click="item.type != 'person' ? action(item) : false"
      >
        <div v-if="item.type == 'person'" class="person">
          <div class="box_info" @click="action(item)">
            <div class="name">
              {{ item.data.name }}
              {{ item.data.surname ? item.data.surname : "" }}
            </div>
            <div class="dni">{{ item.data.dni }}</div>
          </div>
          <div
            class="rel"
            v-for="(role, index) in item.data.roles"
            :key="index"
            @click="action(item, role)"
          >
            <span class="role">{{ role.contact_type.name | i18n }}</span>
            <template v-if="role.club != null || role.team != null">
              <img class="logo" v-if="role.shield" :src="role.shield" />
              <span class="name" v-if="role.name">{{ role.name }}</span>
            </template>
            <span class="event" v-if="role.event">{{
              $root.formatEventName(role.event.name, role.event.edition)
            }}</span>
          </div>
          <div
            class="no_assign"
            v-if="!item.data.roles || item.data.roles.length == 0"
          >
            {{ "not_role" | i18n }}
          </div>
        </div>
        <div v-else-if="item.type == 'club'" class="club">
          <img class="logo" :src="item.data.shield" />
          <span class="name">{{ item.data.name }}</span>
        </div>
        <div v-else-if="item.type == 'team'" class="club">
          <img class="logo" :src="item.data.shield" />
          <span class="name">{{ item.data.name }}</span>
          <span class="event"
            >{{
              $root.formatEventName(
                item.data.event_name,
                item.data.event_edition
              )
            }}
            {{ item.data.category_name }} {{ item.data.category_max_age }}</span
          >
        </div>
      </div>
      <div v-if="is_searching" class="loader"></div>
      <div v-if="!is_searching && values.length == 0" class="">
        {{ "not_results_found" | i18n }}
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  name: "Searcher",
  props: { string: String, refresh: Boolean },
  data() {
    return {
      search: this.string,
      entity: false,
      filter_entity: false,
      search_list: false,
      values: [],
      is_searching: false
    };
  },
  computed: {
    // search: {
    //     get: function(){ return this.string },
    //     set: function( string ){ this.string = string }
    // }
    entities() {
      return [
        { id: "all", name: "Totes les entitats" },
        { id: "club", name: "clubs.label" },
        { id: "person", name: "persons.label" },
        { id: "team", name: "teams.label" }
      ];
    }
  },
  methods: {
    doSearch() {
      if (this.search != "") {
        //this.$store.commit('setSearch', this.search);
        //this.$router.replace( {name: 'search' } );

        var self = this;
        var search = this.search;
        this.$store
          .dispatch("files/searchFiles", { search: search })
          .then(function() {
            self.$store.commit("setLoading", false);
            self.$router.push({ name: "search", query: { s: search } });
          });

        if (this.refresh) this.search = "";
      }
    },

    showFilterEntity() {
      this.filter_entity = !this.filter_entity;
      this.search_list = false;
    },

    setEntity(entity) {
      this.entity = entity == "all" ? false : entity;
      this.filter_entity = false;
      this.search = "";
      this.search_list = false;
      this.is_searching = false;
      this.values = [];
    },

    action(item, role) {
      this.search_list = false;
      this.search = "";

      if (role && role.contact_type.name == "contact_type.volunteer") {
        item.type = "volunteer";
      }

      var event = false;
      if (["person", "volunteer"].includes(item.type) && role && role.event) {
        event = role.event;
      } else if (["person", "volunteer"].includes(item.type)) {
        event = false;
      } else if (item.type == "team") {
        event = {
          name: item.data.event_name,
          edition: item.data.event_edition
        };
      } else {
        event = this.$store.getters.isEventSelected
          ? this.$store.getters["events/getCurrentEvent"]()
          : false;
      }

      var page = item.type + "s_card";
      var params = {
        id: item.data.id
      };
      if (event) {
        page = "event_" + page;
        params.event = this.$root
          .formatEventUrl(event.name, event.edition)
          .replace("\/event\/", "");
      }

      this.$router.push({
        name: page,
        params: params
      });
    }
  },
  watch: {
    search: {
      handler(val) {
        var self = this;
        this.filter_entity = false;
        if (val.trim() == "") {
          self.search_list = false;
          self.values = [];
        } else if (val.length > 2) {
          self.search_list = true;

          self.values = [];
          if (val.trim() == "") {
            self.search_list = false;
          } else {
            self.search_list = true;
            self.is_searching = true;
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var path = "search/" + val.trim();
            path = event ? path + "/event/" + event.id : path;
            path = self.entity ? path + "/" + self.entity : path;
            api.get(path).then(function(response) {
              if (response.status) {
                var data = response.data;
                var aResult = [];
                data.forEach(item => {
                  if (item.type == "person") {
                    // if( item.data.role.club != null ){
                    //   item.data.rel = {
                    //     type: "club",
                    //     name: item.data.role.club.name,
                    //     shield: item.data.role.club.shield,
                    //     role: item.data.role.contact_type.name
                    //   }
                    // }
                    // else if( item.data.role.team != null ){
                    //   item.data.rel = {
                    //     type: "team",
                    //     name: item.data.role.team.name,
                    //     shield: item.data.role.team.shield,
                    //     role: item.data.role.contact_type.name
                    //   }
                    // }
                    // else{
                    //   item.data.rel = false
                    // }
                  }
                });

                self.is_searching = false;
                self.values = data;
              } else {
                self.is_searching = false;
              }
            });
            // self.values = [
            //   { id: 1, type:'person', data: {name: 'Manuel Garcia', rel: { type: 'club', name: 'RCDE', shield:'http://as00.epimg.net/img/comunes/fotos/fichas/equipos/large/8.png', role: 'Delegat'} } },
            //   { id: 2, type:'person', data: {name: 'Manolo Sanchez', rel: { type: 'club', name: 'FCB', shield:'https://img.playbuzz.com/image/upload/ar_1,c_crop/q_auto:good,f_auto,fl_lossy,w_640,c_limit/v1538069387/hlrzbtyvtop8gxzafgx8.png', role: 'Directiu'} } },
            //   { id: 3, type:"club", data: { name: 'Manchester United', shield: 'https://upload.wikimedia.org/wikipedia/en/thumb/7/7a/Manchester_United_FC_crest.svg/1200px-Manchester_United_FC_crest.svg.png' } },
            // ]
          }
        }
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// .search {
//   display: block;
//   overflow: hidden;
//   margin-top: 5px;
//   -webkit-transition: all 1s;
//   transition: all 1s;

//   .input {
//     border: none;
//     border-bottom: 2px solid #ccc;
//     padding: 5px;
//     outline: none;
//     background: url('/img/magnify.svg') no-repeat right 5px center;
//     background-size: 20px;
//     width: 100%;
//     float: left;
//   }
//   .icon {
//     display: none;
//     cursor: pointer;
//     width: 30px;
//     height: 30px;
//     background: url('/img/go.svg') no-repeat center var(--main-color);
//     background-size: 20px;
//     border-radius: 3px;
//     margin-left: 10px;
//   }
//   &.active {

//     .input {
//       width: calc( 100% - 40px );
//       background: transparent;
//     }
//     .icon {
//       display: inline-block;
//     }
//   }

// }
#searcher {
  float: left;
  padding: 7.5px;
  margin-left: 10px;
  z-index: 20;

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: red;
    z-index: $z-header;
    opacity: 0;
  }

  .input {
    background: #fff;
    height: 45px;
    overflow: hidden;
    border-radius: 3px;
    z-index: $z-menus;

    .icon {
      width: 55px;
      height: 45px;
      padding: 12px 15px 12px 5px;
      // background: #ccc;
      display: inline-block;
      float: left;
      background: url("/img/magnify.svg") no-repeat 10px center;
      background-size: 25px;
      border-right: 0px solid #ddd;
      background-color: #fff;
      cursor: pointer;
      position: relative;
      z-index: $z-menus;

      &::after {
        position: absolute;
        right: 5px;
        top: 15px;
        content: "";
        width: 10px;
        height: 10px;
        background: url("/img/down.svg") no-repeat right center;
        background-size: 10px;
      }
      &.expanded {
        width: 150px !important;
        padding-left: 45px !important;
      }
      .entity {
        font-size: 12px;
      }
    }
    input {
      height: 50px;
      width: 250px;
      border: none;
      display: inline-block;
      float: left;
      padding: 10px;
      outline: none;
      background: #e3e5f3;
      z-index: $z-menus;
      position: relative;
    }
  }

  .entity_list {
    position: fixed;
    z-index: $z-header + 1;
    width: 305px;
    top: 82px;
    background-color: #eee;
    border: px solid #000;
    border-top: 0;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    padding: 10px 5px;

    .item {
      width: 100%;
      display: block;
      padding: 8px 8px;
      cursor: pointer;

      &:not(:first-child) {
        border-top: 1px solid #ccc;
      }
    }
  }

  .search_list {
    position: fixed;
    z-index: $z-header + 1;
    width: 305px;
    top: 82px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-top: 0;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    padding: 10px 5px;
    font-size: 16px;
    height: fit-content;
    max-height: 80%;
    overflow: auto;

    &.expanded {
      width: 400px;
    }

    .item {
      width: 100%;
      display: block;
      padding: 5px 5px;
      line-height: 30px;
      position: relative;
      cursor: pointer;

      &.club,
      &.team,
      .box_info,
      .rel {
        background: url("/img/right-arrow.svg") no-repeat center right 5px;
        background-size: 10px;
      }

      .rel {
        border-top: 1px solid #ccc;
      }

      &:not(:first-child) {
        border-top: 2px solid #525050;
      }

      .club {
        width: 100%;
        padding: 2px 0;
        position: relative;

        .logo {
          width: 30px;
          height: 30px;
          vertical-align: middle;
          float: left;
          position: absolute;
        }
        .name {
          display: inline-block;
          padding-left: 10px;
          width: calc(100% - 30px);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-weight: bold;
          margin-left: 30px;
        }
        .event {
          display: inline-block;
          padding-left: 10px;
          width: calc(100% - 30px);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-size: 13px;
          margin-left: 30px;
          margin-top: -5px;
        }
      }

      .person {
        .name {
          display: inline-block;
          width: 40%;
          text-overflow: ellipsis;
          width: 100%;
          font-family: Roboto-Bold;
        }
        .rel {
          display: inline-block;
          width: 100%;

          .role {
            display: inline;
            font-size: 14px;
            font-weight: bold;
            margin: 0;
            margin-right: 10px;
          }
          .logo {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            display: none;
          }
          .name {
            font-size: 14px;
            display: inline;
            margin-left: 0px;
            font-weight: lighter;
            font-family: Roboto-Light;
          }
        }
        .no_assign {
          display: inline-block;
          width: 60%;
          text-align: right;
          font-size: 14px;
          font-style: italic;
        }
      }
    }

    .loader {
      content: "";
      width: 100%;
      height: 150px;
      background: url("/img/loader.svg") no-repeat center center;
      background-size: 75px;
    }
  }
}
</style>
